<template>
  <div>
    <table>
      <tr>
        <th>ID</th>
        <th>AN</th>
        <!-- <th>TITLE</th> -->
        <th>ALID:</th>
        <th>PACKINGS:</th>
        <th>HISTORY:</th>
      </tr>
      <tr v-for="artwork in this.$store.state.artworks" :key="artwork.id">
        <td> {{ artwork.id }}</td>
        <td> {{ artwork.accession_number }}</td>
        <!-- <td> {{ artwork.title }}</td> -->
        <td> {{ artwork.artwork_location_id }}</td>
        <td>
          <!-- {{ aps = getArtworkPackings(artwork.id) }} -->
          <div v-if="getArtworkPackings(artwork.id).length > 0">
            <table>
              <tr v-for="ap in getArtworkPackings(artwork.id)" :key="ap.id">
                <td>{{ ap.colli }}</td>
                <td>{{ ap.location_id }}</td>
                <td>{{ ap.artwork_location_id }}</td>
              </tr>
            </table>
          </div>
        </td>
        <td>
          <!-- {{ aps = getArtworkPackings(artwork.id) }} -->
          <!-- <div v-if="getArtworkLocationHistory(artwork.id).length > 0"> -->
            <table>
              <tr v-for="all in getArtworkLocationHistory(artwork.id)" :key="all.id">
                <td>{{ all.created }}</td>
                <td>{{ all.storage }}</td>
                <td>{{ all.location_id }}</td>
                <td>{{ all.change_date }}</td>
              </tr>
            </table>
          <!-- </div> -->
        </td>
      </tr>
    </table>

  </div>
</template>

<script>
import axios from 'axios'
import { serverBus } from '../../main'

function dynamicSort(property, property2) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    if (a[property] > b[property]) return 1
    if (a[property] < b[property]) return -1
    if (a[property2] && b[property2]) {
      if (a[property2] > b[property2]) return 1
      if (a[property2] < b[property2]) return -1
    }
    return result * sortOrder
  }
}

export default {
  data: () => ({
    // artworks: this.$store.state.artworks
  }),
  computed: {
    old_location_from_date_and_copy() {
      // var current = { change_date: this.artwork_location_log.change_date, copy: this.artwork_location_log.copy, artwork_id: this.artwork.id }
      if (
        this.artwork_location_log.change_date &&
        this.artwork_location_log.copy
      ) {
        // this.artwork_location_log.old_location = this.get_old_location(current)
        if (this.artwork_location_log.copy == 'packings') {
          this.artwork_location_log.artwork_id = ''
          return 'Previous Location cannot be calculated for packings'
        } else if (
          ['artwork', 'master_physical', 'archive_master'].includes(
            this.artwork_location_log.copy
          )
        ) {
          this.artwork_location_log.artwork_id = this.artwork.id
          var olderArtworkLogs = this.sorted_artwork_location_logs.filter(
            (l) =>
              l.copy == this.artwork_location_log.copy &&
              l.change_date < this.artwork_location_log.change_date
          )
          console.log(olderArtworkLogs)
          if (olderArtworkLogs.length > 1) {
            // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_location_log')
            var previous = olderArtworkLogs[0]
            if (previous) {
              this.artwork_location_log.old_location =
                previous.artwork_location_id
              return previous.artwork_location_id
            } else {
              this.artwork_location_log.old_location = 465
              return 465
            }
          } else {
            this.artwork_location_log.old_location = 465
            return 465
          }
        }
      } else {
        return 'Copy and Change Date must be selected before calculating old Location'
      }
    },
    sorted_artwork_location_logs() {
      return this.artwork.artwork_location_logs
        .sort(dynamicSort('change_date', 'change_time'))
        .reverse()
    },
    filtered_artwork_location_logs() {
      return this.sorted_artwork_location_logs.filter(
        (l) => l.copy == this.selectedFilter
      )
    },
    locations() {
      return Object.assign([], this.$store.getters.enabled_locations).sort(
        dynamicSort('name')
      )
    },
    lastLocationLogArtwork() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'artwork')
    },
    lastLocationLogMasterPhysical() {
      return this.getLastLog(
        this.artwork.artwork_location_logs,
        'master_physical'
      )
    },
    lastLocationLogArchiveMaster() {
      return this.getLastLog(
        this.artwork.artwork_location_logs,
        'archive_master'
      )
    },
    lastLocationLogAccessCopy() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'access_copy')
    },
  },
  watch: {
    changeAllParts: function () {
      this.selectAllParts()
    },
    artwork_location_log: {
      handler(val) {
        console.log('watch')
        if (this.artwork_location_log.change_date) {
          this.artwork_location_log.old_location ==
            this.old_location_from_date_and_copy
        }
      },
      deep: true,
    },
  },
  methods: {
    switch_change_dialog() {
      this.showUpload = !this.showUpload
      if (this.showUpload) {
        this.artwork_location_log.old_location =
          this.old_location_from_date_and_copy
      }
    },
    // get_old_location_from_date_and_copy() {
    //   // var current = { change_date: this.artwork_location_log.change_date, copy: this.artwork_location_log.copy, artwork_id: this.artwork.id }
    //   if(this.artwork_location_log.change_date && this.artwork_location_log.copy) {
    //     // this.artwork_location_log.old_location = this.get_old_location(current)
    //     if (this.artwork_location_log.copy == 'packings') {
    //         return 'Previous Location cannot be calculated for packings'
    //     } else if (['artwork','master_physical','archive_master'].includes(this.artwork_location_log.copy)) {
    //       var olderArtworkLogs = this.sorted_artwork_location_logs
    //         .filter(l => l.artwork_id = this.artwork_location_log.artwork_id
    //           && l.copy == this.artwork_location_log.copy
    //           && l.change_date < this.artwork_location_log.change_date)
    //       if (olderArtworkLogs.length > 1) {
    //         // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_location_log')
    //         var previous = olderArtworkLogs[0]
    //         if(previous) {
    //           this.artwork_location_log.old_location = previous.artwork_location_id
    //           return  previous.artwork_location_id
    //         } else {
    //           return 'no previous log for this packing'
    //         }
    //       } else {
    //         return 'no previous log for this packing'
    //       }
    //     }
    //   } else {
    //     return 'Copy and Change Date must be selected before calculating old Location'
    //   }
    // },
    getArtworkPackings(id) {
      return this.$store.state.packings.filter((ap) => ap.artwork_id === id)
    },
    getArtworkLocationHistory(id) {
      return this.$store.state.artwork_location_logs.filter((all) => all.artwork_id === id)
    },
    get_old_location(log) {
      if (log.copy == 'packings') {
        var packingLogs = this.sorted_artwork_location_logs.filter(
          (l) => (l.artwork_packing_id = log.artwork_packing_id)
        )
        if (packingLogs.length > 1) {
          var indexOfcurrent = packingLogs.indexOf(log)
          var previous = packingLogs[indexOfcurrent + 1]
          return previous
            ? this.get_location_name(previous.artwork_location_id)
            : 'no previous log for this packing'
        } else {
          return 'no previous log for this packing'
        }
      } else if (
        ['artwork', 'master_physical', 'archive_master'].includes(log.copy)
      ) {
        var artworkLogs = this.sorted_artwork_location_logs.filter(
          (l) => (l.artwork_id = log.artwork_id && l.copy == log.copy)
        )
        if (artworkLogs.length > 1) {
          var indexOfcurrent = artworkLogs.indexOf(log)
          var previous = artworkLogs[indexOfcurrent + 1]
          return previous
            ? this.get_location_name(previous.artwork_location_id)
            : 'no previous log for this packing'
        } else {
          return 'no previous log for this packing'
        }
      }
      // artwork_location_id
    },
    toggleCopy(c) {
      this.selectedFilter = c
    },
    selectAllParts() {
      if (this.changeAllParts) {
        this.artwork.artwork_packings.forEach((p) => {
          if (!this.selectedPackings.includes(p)) {
            this.selectedPackings.push(p)
          }
        })
      } else {
        this.selectedPackings = []
      }
    },
    getLastLog(logs, copy) {
      if (logs && logs.length > 0) {
        var out = logs
          .filter((ll) => ll.copy === copy)
          .sort(function (a, b) {
            if (a.change_date > b.change_date) {
              return -1
            }
            if (a.change_date < b.change_date) {
              return 1
            }
            return 0
          })[0]
        if (out) {
          return out
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    getPacking(id) {
      return this.artwork.artwork_packings.find((ap) => ap.id === id)
    },
    editLocation(l) {
      this.editedLocationLog = l
      this.editDialog = true
    },
    // location_name (id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.locations.find(l => l.id === id)
    //     if (a) {
    //       return a.name
    //     } else {
    //       return 'Location not found in CMS.'
    //     }
    //   } else {
    //     return 'Location not found in CMS.'
    //   }
    // },
    download() {},
    delete_log(item) {
      let r = confirm(
        'Are you sure you want to delete this Location History entry?'
      )
      if (r) {
        this.delete_log_action(item)
      }
    },
    delete_log_action(item) {
      serverBus.$emit('showSnackbar', 'Deleting Location history.', 'black')
      let url = `${this.$globals.apiserver}/artwork_location_logs/${item.id}.json`
      axios
        .delete(url, item)
        .then((response) => {
          this.$store.dispatch('updateArtwork', this.artwork.id)
          serverBus.$emit('showSnackbar', 'Location history Deleted.', 'green')
          this.errors = {}
          const index = this.artwork.artwork_location_logs.indexOf(item)
          if (index >= 0) this.artwork.artwork_location_logs.splice(index, 1)
          // const index = this.artwork.artwork_costs.indexOf(item)
          // this.artwork.artwork_location_logs.push(response.data);
          // @artwork.artwork_location_id = @artwork_location_log.id
          // elsif @artwork_location_log.copy = 'master_physical'
          // @artwork.master_physical_location_id = @artwork_location_log.id
          // elsif @artwork_location_log.copy = 'archive_master'
          // @artwork.archive_master_location_id = @artwork_location_log.id
          // elsif @artwork_location_log.copy = 'access_copy'
          // @artwork.access_copy_location_id = @artwork_location_log.id
          // this.active_artwork_location_logs = this.artwork.artwork_location_logs
          // this.$store.commit('DELETE_LOG', response.data)
          this.active_artwork_location_logs =
            this.$store.state.artwork_location_logs
          // this.showUpload = !this.showUpload
          return false
        })
        .catch((error) => {
          serverBus.$emit(
            'showSnackbar',
            'There was an Error deleting Cost.',
            'red'
          )
          // console.log(error)
          this.errors = error.response.data
        })
    },
    save_artwork_location_log() {
      this.artwork_location_log.created_by = this.c_user.id
      this.artwork_location_log.artwork_id = this.artwork.id
      this.artwork_location_log.location_id =
        this.artwork_location_log.artwork_location_id
      if (this.artwork_location_log.storage === 'in') {
        this.artwork_location_log.storage_in =
          this.artwork_location_log.change_date
      } else {
        this.artwork_location_log.storage_out =
          this.artwork_location_log.change_date
      }
      // this.artwork_location_log.id = this.findMinMax(this.all_artwork_location_logs)+1
      if (!this.artwork.artwork_location_logs) {
        this.artwork.artwork_location_logs = []
      }
      // this.$store.commit('ADD_TODO', this.artwork_location_log)
      // this.all_artwork_location_logs.push(this.artwork_location_log)
      if (
        this.artwork_location_log.copy === 'packings' &&
        this.selectedPackings &&
        this.selectedPackings.length > 0
      ) {
        // console.log('packings')
        for (const sp in this.selectedPackings) {
          // console.log(this.selectedPackings[sp].id)
          this.artwork_location_log.artwork_packing_id =
            this.selectedPackings[sp].id
          console.log(this.artwork_location_log)
          axios
            .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
              artwork_location_log: this.artwork_location_log,
            })
            .then((response) => {
              this.errors = {}
              // this.artwork.artwork_location_logs.push(response.data);
              // @artwork.artwork_location_id = @artwork_location_log.id
              // elsif @artwork_location_log.copy = 'master_physical'
              // @artwork.master_physical_location_id = @artwork_location_log.id
              // elsif @artwork_location_log.copy = 'archive_master'
              // @artwork.archive_master_location_id = @artwork_location_log.id
              // elsif @artwork_location_log.copy = 'access_copy'
              // @artwork.access_copy_location_id = @artwork_location_log.id
              // this.active_artwork_location_logs = this.artwork.artwork_location_logs
              this.$store.commit('ADD_LOG', response.data)
              this.active_artwork_location_logs =
                this.$store.state.artwork_location_logs
              this.showUpload = !this.showUpload
            })
            .catch((error) => {
              // console.log(error)
              // this.errors = error.response.data;
            })
        }

        if (this.changeArtworkLocation) {
          axios
            .put(
              `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`,
              {
                artwork: {
                  artwork_location_id:
                    this.artwork_location_log.artwork_location_id,
                },
              }
            )
            .then((response) => {
              this.errors = {}
              this.artwork.artwork_location_logs.push(response.data)
              if (this.artwork_location_log.copy === 'artwork') {
                this.artwork.artwork_location_id =
                  this.artwork_location_log.artwork_location_id
              } else if (this.artwork_location_log.copy === 'master_physical') {
                this.artwork.master_physical_location_id =
                  this.artwork_location_log.artwork_location_id
              } else if (this.artwork_location_log.copy === 'archive_master') {
                this.artwork.archive_master_location_id =
                  this.artwork_location_log.artwork_location_id
              } else if (this.artwork_location_log.copy === 'access_copy') {
                this.artwork.access_copy_location_id =
                  this.artwork_location_log.artwork_location_id
              }
              this.$store.commit('ADD_LOG', response.data)
              this.active_artwork_location_logs =
                this.$store.state.artwork_location_logs
              this.changeArtworkLocation = false
            })
        }

        this.artwork_location_log = {
          created_by: this.c_user.id,
          storage: 'in',
          note: '',
          change_date: '',
          copy: 'artwork',
          shipper: '',
          reason: '',
          artwork_location_id: '',
          artwork_packing_id: '',
        }
        this.$store.dispatch('loadPackings')
        this.$emit('getArtwork')
      } else {
        // console.log('single')
        axios
          .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
            artwork_location_log: this.artwork_location_log,
          })
          .then((response) => {
            this.errors = {}
            this.artwork.artwork_location_logs.push(response.data)
            if (this.artwork_location_log.copy === 'artwork') {
              this.artwork.artwork_location_id =
                this.artwork_location_log.artwork_location_id
            } else if (this.artwork_location_log.copy === 'master_physical') {
              this.artwork.master_physical_location_id =
                this.artwork_location_log.artwork_location_id
            } else if (this.artwork_location_log.copy === 'archive_master') {
              this.artwork.archive_master_location_id =
                this.artwork_location_log.artwork_location_id
            } else if (this.artwork_location_log.copy === 'access_copy') {
              this.artwork.access_copy_location_id =
                this.artwork_location_log.artwork_location_id
            }
            this.$store.commit('ADD_LOG', response.data)
            this.active_artwork_location_logs =
              this.$store.state.artwork_location_logs
            this.showUpload = !this.showUpload
            this.artwork_location_log = {
              created_by: this.c_user.id,
              storage: 'in',
              note: '',
              change_date: '',
              copy: 'artwork',
              shipper: '',
              reason: '',
              artwork_location_id: '',
              artwork_packing_id: '',
            }
          })
          .catch((error) => {
            // console.log(error)
          })
        this.$emit('getArtwork')
      }
      this.selectedPackings = []
      this.editDialog = false
      // var aartwork_location_log = Object.keys(this.artwork_location_log).forEach(k => this.artwork_location_log[k]='')
      // console.log(aartwork_location_log)
    },
    save_edited_artwork_location_log() {
      this.editedLocationLog.last_update_by = this.c_user.id
      this.editedLocationLog.artwork_id = this.artwork.id
      if (this.editedLocationLog.storage === 'in') {
        this.editedLocationLog.storage_in = this.editedLocationLog.change_date
      } else {
        this.editedLocationLog.storage_out = this.editedLocationLog.change_date
      }
      if (
        this.editedLocationLog.copy === 'packings' &&
        this.selectedPackings &&
        this.selectedPackings.length > 0
      ) {
        for (const sp in this.selectedPackings) {
          this.editedLocationLog.artwork_packing_id =
            this.selectedPackings[sp].id
          axios
            .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
              artwork_location_log: this.editedLocationLog,
            })
            .then((response) => {
              this.errors = {}
              // this.artwork.artwork_location_logs.push(response.data);
              // @artwork.artwork_location_id = @editedLocationLog.id
              // elsif @editedLocationLog.copy = 'master_physical'
              // @artwork.master_physical_location_id = @editedLocationLog.id
              // elsif @editedLocationLog.copy = 'archive_master'
              // @artwork.archive_master_location_id = @editedLocationLog.id
              // elsif @editedLocationLog.copy = 'access_copy'
              // @artwork.access_copy_location_id = @editedLocationLog.id
              // this.active_artwork_location_logs = this.artwork.artwork_location_logs
              this.$store.commit('UPDATE_LOG', response.data)
              this.active_artwork_location_logs =
                this.$store.state.artwork_location_logs
              this.showUpload = !this.showUpload
            })
            .catch((error) => {
              // console.log(error)
              // this.errors = error.response.data;
            })
        }
        this.artwork_location_log = {
          storage: 'in',
          note: '',
          change_date: '',
          copy: 'artwork',
          shipper: '',
          reason: '',
          artwork_location_id: '',
          artwork_packing_id: '',
        }
      } else {
        axios
          .put(
            `${this.$globals.apiserver}/artwork_location_logs/${this.editedLocationLog.id}.json`,
            {
              artwork_location_log: this.editedLocationLog,
            }
          )
          .then((response) => {
            this.$emit('getArtwork')
            this.errors = {}
            this.artwork.artwork_location_logs = [
              ...this.artwork.artwork_location_logs.filter(
                (element) => element.id !== response.data.id
              ),
              response.data,
            ]
            if (this.editedLocationLog.copy === 'artwork') {
              this.artwork.artwork_location_id =
                this.editedLocationLog.artwork_location_id
            } else if (this.editedLocationLog.copy === 'master_physical') {
              this.artwork.master_physical_location_id =
                this.editedLocationLog.artwork_location_id
            } else if (this.editedLocationLog.copy === 'archive_master') {
              this.artwork.archive_master_location_id =
                this.editedLocationLog.artwork_location_id
            } else if (this.editedLocationLog.copy === 'access_copy') {
              this.artwork.access_copy_location_id =
                this.editedLocationLog.artwork_location_id
            }
            // this.$store.commit("UPDATE_LOG", response.data);
            this.active_artwork_location_logs =
              this.$store.state.artwork_location_logs
            // this.showUpload = !this.showUpload;
            this.editedLocationLog = {
              storage: 'in',
              note: '',
              change_date: '',
              change_time: '',
              copy: 'artwork',
              shipper: '',
              reason: '',
              artwork_location_id: '',
              artwork_packing_id: '',
            }
            this.editDialog = false
          })
          .catch((error) => {
            // console.log(error)
          })
      }
      // var aartwork_location_log = Object.keys(this.artwork_location_log).forEach(k => this.artwork_location_log[k]='')
      // console.log(aartwork_location_log)
    },
  },
}
</script>

<style scoped>
/* .activeToggle { background-color: gold; color:hotpink; } */
</style>



// WEBPACK FOOTER //
// src/components/artworks/LocationOverview.vue